import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import PremiumBenefits from '../../GuildDashboard/components/PremiumBenefits'
import { useGuild } from 'app/frontend/base/config/context/guild'

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
}

const PremiumBenefitsModal = ({ open, setOpen }: Props) => {
  const { guild } = useGuild()

  if (!guild) return null

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className='max-w-5xl'>
        <DialogHeader>
          <DialogTitle className='mb-2'>
            Apply boosts to {guild.name}
          </DialogTitle>
          {open ? (
            <PremiumBenefits
              guild={guild}
              legacyTier={guild.legacyPatron?.details?.pledge_tier}
              benefits={guild.premiumBenefits || []}
            />
          ) : null}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}

export default PremiumBenefitsModal
